import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  signal
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeatureStateService } from 'src/app/shared/services/feature-state.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { getHowToScopesFromRoute } from 'src/app/shared/utils/how-to-route.util';

import { PageHowToToolbarService } from './page-how-to-toolbar.service';

@Component({
  selector: 'app-page-how-to-toolbar-btn',
  standalone: true,
  imports: [CommonModule, NzButtonModule, NzIconModule, NzToolTipModule],
  templateUrl: './page-how-to-toolbar-button.component.html',
  styleUrls: ['./page-how-to-toolbar-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHowToToolbarButtonComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private featureState = inject(FeatureStateService);
  private toolbar = inject(PageHowToToolbarService);
  private destroy$ = new Subject<void>();

  private scopes = signal<string[]>([]);

  showHowTo = computed(
    () => this.scopes().length > 0 && this.featureState.isInternal()
  );

  ngOnInit(): void {
    this.updateScope();
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.updateScope());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOpen(): void {
    this.toolbar.requestOpen();
  }

  private updateScope(): void {
    this.scopes.set(getHowToScopesFromRoute(this.router));
  }
}
